import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/bg3.png'


const _withScopeId = n => (_pushScopeId("data-v-14e1935a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pros-exist-user overflow-x-hide" }
const _hoisted_2 = { class: "container no-padding" }
const _hoisted_3 = { class: "col-sm-12 col-md-12 row my-auto no-padding no-margin" }
const _hoisted_4 = {
  class: "col-sm-12 col-12 col-md-12 row no-padding no-margin",
  style: {"align-items":"center"}
}
const _hoisted_5 = { class: "col-sm-12 col-md-4 offset-md-2 text-container tab-container no-padding flex-container" }
const _hoisted_6 = { class: "content-left" }
const _hoisted_7 = { class: "content-sec1" }
const _hoisted_8 = { class: "content-sec2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "content-sec3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-6 tab-image-container flex-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "img-laptop"
  })
], -1))
const _hoisted_12 = { class: "footer row d-sm-none d-md-block d-none d-sm-block page-footer no-margin" }
const _hoisted_13 = { href: "https://cybersystem.io" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headerlogo = _resolveComponent("headerlogo")!
  const _component_v_runtime_template = _resolveComponent("v-runtime-template")!
  const _component_errorhandler = _resolveComponent("errorhandler")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_headerlogo, { "page-type": '1' }),
      _createElementVNode("div", {
        class: "row no-padding main-body h-100",
        style: _normalizeStyle({ height: _ctx.windowHeight })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.getUiText("app-prospect-callback-whoops-user-heading-1")), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.getUiText("app-prospect-callback-whoops-user-heading-sub-1")), 1),
                  _hoisted_9
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_v_runtime_template, { template: _ctx.userHelpText }, null, 8, ["template"])
                ])
              ])
            ]),
            _hoisted_11
          ])
        ])
      ], 4),
      (_ctx.showProspectCallbackError || null)
        ? (_openBlock(), _createBlock(_component_errorhandler, {
            key: 0,
            "prospect-callback-error-msg": _ctx.prospectCallbackErrorMsg,
            onResetShowProspectCallbackError: _ctx.resetShowProspectCallbackError
          }, null, 8, ["prospect-callback-error-msg", "onResetShowProspectCallbackError"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createTextVNode(_toDisplayString(_ctx.getUiText("app-prospect-nav-cms-text-1")) + " ", 1),
        _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.getUiText("app-prospect-nav-cms-link-1")), 1)
      ])
    ])
  ]))
}